<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h5 font-weight-bold text-primary">Hot & New Businesses</div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <HotAndNewBusinessCard 
                        imgSrc="https://i.imgur.com/gSfjYqD.jpg"
                        businessName="Turks"
                        :averageRating=4.1
                        :numberOfRatings=5
                        categories="Turkish, Arabic"
                        subCity="Binondo"
                        newness="Opened 2 weeks ago"
                    />
                </b-col>
                <b-col>
                    <HotAndNewBusinessCard 
                        imgSrc="https://i.imgur.com/ndij8PC.jpg"
                        businessName="Manangs"
                        :averageRating=4.1
                        :numberOfRatings=7
                        categories="Filipino, Merienda"
                        subCity="Intramuros"
                        newness="Opened 3 weeks ago"
                    />
                </b-col>
                <b-col>
                    <HotAndNewBusinessCard 
                        imgSrc="https://i.imgur.com/qKOATsq.jpg"
                        businessName="Subway"
                        :averageRating=4.2
                        :numberOfRatings=11
                        categories="American, Fastfood"
                        subCity="Ermita"
                        newness="Opened 7 weeks ago"
                    />
                </b-col>
            </b-row>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <b-link class="text-success">
                        See more hot and new businesses
                    </b-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    width: 100%;
}

</style>

<script>
import HotAndNewBusinessCard from './HotAndNewBusinessCard'

export default {
    components: {
        HotAndNewBusinessCard
    },
    data() {
        return {
            
        }
    }
}
</script>